import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const BACKEND_ORIGIN = BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export function getAuthHeaders() {
  const token = localStorage.getItem("auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("auth_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatINR(amount) {
  if (typeof amount !== "number") amount = Number(amount) || 0;
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(amount);
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

/** Download a booking voucher PDF via authenticated fetch */
export async function downloadVoucher(bookingId, refNo) {
  try {
    const resp = await api.get(`/bookings/${bookingId}/voucher`, { responseType: "blob" });
    const url = window.URL.createObjectURL(new Blob([resp.data], { type: "application/pdf" }));
    const a = document.createElement("a");
    a.href = url;
    a.download = `voucher-${refNo || bookingId}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch {
    window.open(`${API_BASE}/bookings/${bookingId}/voucher`, "_blank");
  }
}

/** Open a printable HTML ticket via authenticated fetch */
export async function printTicket(bookingId) {
  try {
    const resp = await api.get(`/bookings/${bookingId}/voucher?format=html`, { responseType: "text" });
    const printWin = window.open("", "_blank");
    if (printWin) {
      printWin.document.write(resp.data);
      printWin.document.close();
      printWin.onload = () => printWin.print();
    }
  } catch {
    window.open(`${API_BASE}/bookings/${bookingId}/voucher?format=html`, "_blank");
  }
}
